jQuery(function($) {
    "use strict";
  
    AOS.init({
      easing: 'ease-in-out-sine'
    });
  
  var owl_load = function(){
    var owl = $('.banner-slider');
    owl.owlCarousel({
      margin: 0,
      autoplay: true,
      autoplayTimeout: 7000,
      autoplayHoverPause:true,
      autoHeight: true,
      loop: true,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });
    
  
  var owl = $('.irrigation-slider');
    owl.owlCarousel({
      margin: 0,
      autoplay: true,
      autoplayTimeout: 7000,
      autoplayHoverPause:true,
      autoHeight: true,
      loop: true,
      nav: true,
      dots: true,
      responsive:{
        0:{
            items:1
        },
        600:{
            items:4
        },
        1000:{
            items:6
        }
    }
    });
    
    var icon_carousel = $('.icon-carousel-slider');
    icon_carousel.owlCarousel({
        margin: 0,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause:true,
        autoHeight: true,
        loop: true,
        nav: true,
        dots: true,
        responsive:{
          0:{
              items:1
          },
          600:{
              items:4
          },
          1000:{
              items:6
          }
    	}
    });
    
    var logo_slider = $('.wir-logo-slider');
    logo_slider.owlCarousel({
      margin: 10,
      autoplay: true,
      autoplayTimeout: 7000,
      autoplayHoverPause:true,
      autoHeight: true,
      loop: true,
      nav: true,
      dots: true,
      responsive:{
        0:{
            items:2,
          	margin: 20
        },
        600:{
            items:4
        },
        1000:{
            items:5
        }
    }
    });
    
  
  
  var owl = $('.testimonials-slider');
    owl.owlCarousel({
      margin: 0,
      autoplay: true,
      stagePadding: 250,
      autoplayTimeout: 7000,
      autoplayHoverPause:true,
      autoHeight: true,
      loop: true,
      nav: true,
      responsive: {
        0: {
          stagePadding: 0,
          items: 1
        },
        576: {
          stagePadding: 0,
          items: 2
        },
        768: {
          stagePadding: 0,
          items: 3
        },
        1024: {
          stagePadding: 0,
          items: 3
        },
        1650: {
          stagePadding: 180,
          items: 3
        },
        1920: {
          stagePadding: 250,
          items: 3
        }
      }
    });
    

    if($(".blog-tag-slider").length > 0 ) {
        $(".blog-tag-slider").each( function(){
            var $this = $(this);
            if($this.hasClass('owl-carousel')) {
                $this.owlCarousel({
                    margin: 30,
                    autoplay: true,
                    autoplayTimeout: 7000,
                    autoplayHoverPause:true,
                    autoHeight: true,
                    loop: true,
                    nav: true,
                    responsive: {
                        0: {
                            items: 1
                        },
                        576: {
                            items: 1
                        },
                        768: {
                            items: 2
                        },
                        1024: {
                            items: 2
                        },
                        1650: {
                            items: 2
                        },
                        1920: {
                            items: 2
                        }
                    }
                });
            }
        });   
    }
    
  
  var owl = $('.home-tipps-slider');
    owl.owlCarousel({
      margin: 30,
      autoplay: true,
      stagePadding: 250,
      autoplayTimeout: 7000,
      autoplayHoverPause:true,
      autoHeight: true,
      loop: true,
      navigation: true,
      responsive: {
        0: {
          stagePadding: 0,
          items: 1
        },
        575: {
          stagePadding: 0,
          items: 1
        },
        625: {
          stagePadding: 0,
          items: 2
        },
        800: {
          stagePadding: 0,
          items: 3
        },
        1600: {
          stagePadding: 0,
          items: 3
        }
      }
    });
  
    var owl = jQuery('.register-slider');
        owl.owlCarousel({
        margin: 0,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause:true,
        autoHeight: true,
        loop: true,
        nav: false,
        dots: true,
        responsive: {
            0: {
            items: 1
            },
            600: {
            items: 1
            },
            1000: {
            items: 1
            }
        }
        });
  
   var productSidedeals = $(".widget-featured-product .products-grid");
      productSidedeals.owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        navContainer: ".widget-featured-nav",
        navText: [' <a class="prev active"><i class="icon-arrow-left icons"></i></a>',' <a class="prev active"><i class="icon-arrow-right icons"></i></a>'],
        dots: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
      });
  
 /*var owl = jQuery('.orders-table-slider');
     owl.owlCarousel({
     margin: 30,
     autoplay: true,
     stagePadding: 0,
     autoplayTimeout: 7000,
     autoplayHoverPause:true,
     autoHeight: true,
     loop: true,
     navigation: true,
     animateIn: 'fadeIn',
     animateOut: 'fadeOut',
     responsive: {
         0: {
         stagePadding: 0,
         items: 1
         },
         600: {
         stagePadding: 0,
         items: 1
         },
         1000: {
         stagePadding: 0,
         items: 1
         },
         1600: {
         stagePadding: 0,
         items: 1
         }
     }
     });
     */
    $('.owl-nav button').on('click', function(e) {
        $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
    })
    $('.owl-dots button').on('click', function(e) {
        $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
    })
    $('.owl-carousel').on('click', function(e) {
        $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
    })
    
    $('.owl-carousel').on("dragged.owl.carousel", function (event) {
      console.log(event);
      $(this).trigger('stop.owl.autoplay');
    });
    
  }
  
  owl_load();
  
  $(document)
 .on( 'shopify:section:load', owl_load )
 .on( 'shopify:section:unload', owl_load ); 
  
  var closeDropdownCart = function (){
    if ($("#slidedown-cart").is(":visible")) {
      $("#slidedown-cart").removeClass("active")
    }
  }
  
    $(document).on("click touchstart", function(n) {           
      var i = $("#slidedown-cart");
      var s = $("#ToggleDown");

      if (!i.is(n.target) && i.has(n.target).length === 0 && !s.is(n.target) && s.has(n.target).length === 0 ) {
        closeDropdownCart();

      }
    });
  
  $(document).keyup(function(n) {
        if (n.keyCode == 27) {

            closeDropdownCart();
        }
    });
  
  var checkItemsInDropdownCart = function(){
    if ($("#slidedown-cart .mini-products-list").children().length > 0) {
      $("#slidedown-cart .no-items").hide();
      $("#slidedown-cart .has-items").show();
      $("#slidedown-cart .cart-summary").show();
      $("#slidedown-cart .cart-actions").show();
    } else {
      $("#slidedown-cart .has-items").hide();
      $("#slidedown-cart .no-items").show();
      $("#slidedown-cart .cart-summary").hide();
      $("#slidedown-cart .cart-actions").hide();
    }
  }
  
  if (window.dropdowncart_type == "click") {
    $("#ToggleDown").click(function(e) {
      e.preventDefault();
      if ($("#slidedown-cart").is(":visible")) {
        $("#slidedown-cart").addClass("active")
      } else {
        $("#slidedown-cart").removeClass("active")
      }
    })
  } else {
    if (!("ontouchstart" in document)) {
      $("#ToggleDown").hover(function() {
        if (!$("#slidedown-cart").is(":visible")) {
          $("#slidedown-cart").addClass("active")
        }
      });
      $("#ToggleDown").mouseleave(function() {
        $("#slidedown-cart").removeClass("active")
      })
    } else {
      $("#ToggleDown").click(function(e) {
        e.preventDefault();
        if ($("#slidedown-cart").is(":visible")) {
          $("#slidedown-cart").addClass("active")
        } else {
          $("#slidedown-cart").removeClass("active")
        }
      })
    }
  }
  
  checkItemsInDropdownCart();
  
  var checkNeedToConvertCurrency = function() {
    return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
  }
  
  var doUpdateDropdownCart = function(n) {
    var r = '<li class="item" id="cart-item-{ID}"><div class="product-image"><a href="{URL}" title="{TITLE}" class="pro-image"><img src="{IMAGE}" alt="{TITLE}"></a></div><div class="product-details"><h3 class="product-title"><a href="{URL}">{TITLE}</a></h3><h3 class="product-price">{PRICE}</h3><div class="product-actions"><div class="product-qty"><button class="qty-minus adjust minus"><i class="fa fa-minus"></i></button><input class="tc item-quantity" type="text" name="updates[]" data-id="{ID}" id="updates_{ID}" value="{QUANTITY}" /><button class="qty-plus adjust plus"><i class="fa fa-plus"></i></button></div><div class="btn-remove"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><span class="fas fa-times"></span></a></div></div></div></li>';
    $("#cartCount").text(n.item_count );
    $("#slidedown-cart span.price").html(Shopify.formatMoney(n.total_price, window.money_without_format));
    $("#slidedown-cart .mini-products-list").html("");
    if (n.item_count > 0) {
      for (var i = 0; i < n.items.length; i++) {
          var s = r;
          s = s.replace(/\{ID\}/g, n.items[i].id);
          s = s.replace(/\{URL\}/g, n.items[i].url);
          s = s.replace(/\{TITLE\}/g, n.items[i].title);
          s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
          s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
          s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].price, window.money_without_format));
          $("#slidedown-cart .mini-products-list").append(s)
        }
        $("#slidedown-cart .btn-remove").click(function(n) {
          n.preventDefault();
          var r = $(this).parents(".item").attr("id");
          r = r.match(/\d+/g);
          Shopify.removeItem(r, function(e) {
            doUpdateDropdownCart(e);                      
          });
        });
      
    }
    checkItemsInDropdownCart();
    $("#slidedown-cart").addClass("active");
  }
  
  $("#slidedown-cart .no-items a").click(function() {
    $("#slidedown-cart").removeClass("active");
  });
  
  $("#slidedown-cart .cart-popup-close").click(function() {
    $("#slidedown-cart").removeClass("active");
  });
  
  $("#slidedown-cart .btn-remove").click(function(n) {
    n.preventDefault();
    var r = $(this).parents(".item").attr("id");
    r = r.match(/\d+/g);
    Shopify.removeItem(r, function(e) {
      doUpdateDropdownCart(e);
    });
  });
  
  var showList = function (e) {
        var $gridCont = $('.grid-container');
        var $btnContGrid = $('.btnContainer .btn.btn-grid');
        var $btnContList = $('.btnContainer .btn.btn-list');
        e.preventDefault();
      $gridCont.removeClass('list-view');
      $gridCont.addClass('list-view');
        //$gridCont.hasClass('list-view') ? $gridCont.removeClass('list-view') : $gridCont.addClass('list-view');
        $btnContGrid.removeClass('active');
        $btnContList.addClass('active');
      $('a.blog-filter_active').trigger('click');
    }
  
    var gridList = function (e) {
        var $gridCont = $('.grid-container');
        var $btnContGrid = $('.btnContainer .btn.btn-grid');
        var $btnContList = $('.btnContainer .btn.btn-list');
        e.preventDefault();
        $gridCont.removeClass('list-view');
      
        $btnContGrid.addClass('active');
        $btnContList.removeClass('active');
      $('a.blog-filter_active').trigger('click');
    }
    
    $(document).on('click', '.btn-grid', gridList);
    $(document).on('click', '.btn-list', showList);
  
  
    /*
    
    if ($(".page-tips-tricks-section .blog-items").length) {
      var a = $(".page-tips-tricks-section .blog-items").isotope({
        singleMode: true,
        masonry: {
          columnWidth: '.grid-sizer, .grid-sizer-second, .grid-sizer-three'
        },
        //columnWidth: ".grid-sizer, .grid-sizer-second, .grid-sizer-three",
        itemSelector: ".blog-item, .blog-item-second, .blog-item-three",
        transformsEnabled: true,
        transitionDuration: "700ms",
        layoutMode: 'fitRows'
      });
      a.imagesLoaded(function() {
        a.isotope("layout");
      });
      
      $(".page-tips-tricks-section .blog-filters").on("click", "a.blog-filter", function(b) {
        b.preventDefault();
        var c = $(this).attr("data-filter");
        a.isotope({
          filter: c
        });
        $(".page-tips-tricks-section .blog-filters a.blog-filter").removeClass("blog-filter_active");
        $(this).addClass("blog-filter_active");
        return false;
      });
      a.isotope("on", "layoutComplete", function(a, b) {
        //var c = b.length;
        //$(".num-album").html(c);
      });
    }
    
    */
  
    
    /*
    Show/hide the recover password form when requested.
  */
    var showHidePassword = function(e) {
        e.preventDefault();
        var x = $('#CustomerPassword');
        var eye = $('#checkPassword');
      
      if(eye.hasClass('fa-eye')) {
        x.attr("type", "text");
        eye.removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        x.attr("type", "password");
        eye.removeClass('fa-eye-slash').addClass('fa-eye');
      }

    }
  
    $(document).on('click', '#checkPassword', showHidePassword);
  
 /*
    Show/hide the recover password form when requested.
  */
  var showRecoverPasswordForm = function(e) {
    e.preventDefault();
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  }
  
  var hideRecoverPasswordForm = function(e) {
    e.preventDefault();
    $('#RecoverPasswordForm').hide();
    $('#CustomerLoginForm').show();
  }
  
  $(document).on('click', '#showRecoverPasswordForm', showRecoverPasswordForm);
  
  $(document).on('click', '#hideRecoverPasswordForm', hideRecoverPasswordForm);
  
  // Allow deep linking to the recover password form
  if (window.location.hash == '#recover') { showRecoverPasswordForm() }

  

  
  
  var updateDropdownCart =  function() {
     Shopify.getCart(function($) {
       doUpdateDropdownCart($)
     })
   }

  var doAjaxAddToCart = function(n, r, a, p, amt) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + n,
                dataType: "json",
                success: function(n) {
                    updateDropdownCart();
                },
                error: function(n, r) {
          var errStatus = $.parseJSON(n.responseText).status;
                    
                  if(errStatus == 422){
                    alert($.parseJSON(n.responseText).description);
                  }
                }
            })
    }
  
    var initProductAddToCart = function() {
    if ($("#AddToCart").length > 0) {
      $("#AddToCart").click(function(n) {
        n.preventDefault();
        if ($(this).attr("disabled") != "disabled") {
          if (!window.ajax_cart) {
            $(this).closest("form").submit()
          } else {
            var r = $("#AddToCartForm select[name=id]").val();
            if (!r) {
              r = $("#AddToCartForm input[name=id]").val()
            }
            var i = $("#AddToCartForm input[name=quantity]").val();
            if (!i) {
              i = 1
            }                          
            var o = $("#product-featured-image").attr("src");
            var p = $("#popup_cart_title").text();
            var amt = $(".shop-product__price .discounted-price span.money").text();
            console.log(amt);
            doAjaxAddToCart(r, i, o, p, amt);
          }
        }
        return false
      });
    }
      
    if ($("#AddToCartFeatured").length > 0) {
      $("#AddToCartFeatured").click(function(n) {
        n.preventDefault();
        if ($(this).attr("disabled") != "disabled") {
          if (!window.ajax_cart) {
            $(this).closest("form").submit()
          } else {
            var r = $("#AddToCartFeaturedForm select[name=id]").val();
            if (!r) {
              r = $("#AddToCartFeaturedForm input[name=id]").val()
            }
            var i = $("#AddToCartFeaturedForm input[name=quantity]").val();
            if (!i) {
              i = 1
            }                          
            var o = $("#product-featured-image").attr("src");
            var p = $("#popup_cart_title").text();
            var amt = $(".shop-product__price .discounted-price span.money").text();
            console.log(amt);
            doAjaxAddToCart(r, i, o, p, amt);
          }
        }
        return false
      });
    }  
  }
  initProductAddToCart();
  
$('body').on('click', '#slidedown-cart .adjust',function(e){
  	e.preventDefault();
      var input = $(this).parent().find('input');
      var ip = parseInt(input.val());
      if($(this).hasClass('plus')) {
        ip = ip + 1;
      } else {
        ip = ip - 1;
      }
      if(ip==0) {
        return false;
      }
      input.val(ip);


      var id = parseInt(input.attr('data-id'));
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'updates['+id+']='+ip,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);

        }
      }).done(function( data ) {
    updateDropdownCart();
      });
    });
  
  $('body').on('click', '.mini-products-list.in-mobile .adjust',function(e){
  	e.preventDefault();
      var input = $(this).parent().find('input');
      var ip = parseInt(input.val());
      if($(this).hasClass('plus')) {
        ip = ip + 1;
      } else {
        ip = ip - 1;
      }
      if(ip==0) {
        return false;
      }
      input.val(ip);

    });

 $(document.body).on('click', '.alt-pr-tag:not(.checked )',function(e){
   //e.preventDefault();
   var $this = $(this);
   $('.alt-pr-tag').removeClass('checked');
   $this.addClass('checked');
   var url = $this.data('url');
   window.location.href = url;
 });
  
  var isEmail = function(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  
  $(document.body).on('click', '.btn-newsletter',function(e){
   e.preventDefault();
   var $this = $(this);
    var id = $this.data('id');
    var email = $('#'+id+'-email').val();
    var email_required = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var email_invalid = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var checkbox = 'Bitte akzeptiere die Datenschutzerklärung.';
    if(email == ''){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_required+'</li></ul></div>');
    } else if(!isEmail(email)){
       $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_invalid+'</li></ul></div>');       
    } else if($('#defaultCheck1').prop("checked") == false){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+checkbox+'</li></ul></div>'); 
    } else {
      $this.closest('form').submit();
    }
 });
  
  $(document.body).on('click', '.btn-contact',function(e){
   e.preventDefault();
   var $this = $(this);
    var id = $this.data('id');
    var name = $('#'+id+'-name').val();
    var email = $('#'+id+'-email').val();
    var message = $('#'+id+'-message').val();
    var name_required = 'Bitte trage eine Name ein.';
    var message_required = 'Bitte trage eine Nachricht ein.';
    var email_required = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var email_invalid = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var checkbox = 'Bitte akzeptiere die Datenschutzerklärung.';
    if(name == '') {
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+name_required+'</li></ul></div>');
    } else if(email == ''){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_required+'</li></ul></div>');
    } else if(!isEmail(email)){
       $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_invalid+'</li></ul></div>');       
    } else if(message == ''){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+message_required+'</li></ul></div>'); 
    } else if($('#defaultCheck1').prop("checked") == false){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+checkbox+'</li></ul></div>'); 
    } else {
      $this.closest('form').submit();
    }
 });
  
  
  $(document.body).on('click', '.cstm_contact_btn',function(e){
   e.preventDefault();
   var $this = $(this);
    var id = $this.data('id');
    var email = $('#'+id+'-email').val();
    var email_required = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var email_invalid = 'Bitte trage eine gültige E-Mail-Adresse ein.';
    var checkbox = 'Bitte akzeptiere die Datenschutzerklärung.';
    if(email == ''){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_required+'</li></ul></div>');
    } else if(!isEmail(email)){
       $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+email_invalid+'</li></ul></div>');       
    } else if($('#defaultCheck1').prop("checked") == false){
      $('#form-error-'+id).empty().html('<div class="errors"><ul><li>'+checkbox+'</li></ul></div>'); 
    } else {
      $this.closest('form').submit();
    }
 });
  
  var initShopify = function(){
    $(document.body).on('click', '.team-load-more a',function(e){
     e.preventDefault();
     var $this = $(this);
      var count = 0;
      var count2 = 0;
      $(".team-loop").each(function(i,v){
        if($(this).hasClass('d-none')){
          count++;
          if(count > 6){
            return;
          }
          $(this).removeClass('d-none');
          
        }
      });
      
      $(".team-loop").each(function(i,v){
        if($(this).hasClass('d-none')){
          count2++;
        }
      });
      
      
      if(count2 == 0) {
        $this.hide();
      }
   });
    
    $(document.body).on('click', '.accordion-load-more a',function(e){
     e.preventDefault();
     var $this = $(this);
      var count = 0;
      var count2 = 0;
      $(".accordion-loop").each(function(i,v){
        if($(this).hasClass('d-none')){
          count++;
          if(count > 3){
            return;
          }
          $(this).removeClass('d-none');
          
        }
      });
      
      $(".accordion-loop").each(function(i,v){
        if($(this).hasClass('d-none')){
          count2++;
        }
      });
      
      
      if(count2 == 0) {
        $this.hide();
      }
   });
    
    $(document.body).on('click', '.register-btn',function(e){
     e.preventDefault();
     var $this = $(this);
      var email = $('#Email').val();
      var password = $('#CreatePassword').val();
      var email_required = 'E-mail darf nicht unausgefüllt sein.';
      var password_required = 'Passwort darf nicht unausgefüllt sein.';
      var email_invalid = 'Bitte trage eine gültige E-Mail-Adresse ein.';
      var checkbox = 'Bitte akzeptieren Sie die Datenschutzbestimmungen.';
      if(email == ''){
          $('.register-error').empty().html('<div class="errors"><ul><li>'+email_required+'</li></ul></div>');
      } else if(!isEmail(email)){
         $('.register-error').empty().html('<div class="errors"><ul><li>'+email_invalid+'</li></ul></div>');       
      } else if(password == ''){
          $('.register-error').empty().html('<div class="errors"><ul><li>'+password_required+'</li></ul></div>'); 
      } else if($('#privacy_check').prop("checked") == false){
          $('.register-error').empty().html('<div class="errors"><ul><li>'+checkbox+'</li></ul></div>'); 
      } else {
          $this.closest('form').submit();
      }
   });
    
      // SLICK
    /*
     $('#product-slider__main').slick({
      asNavFor: '#product-slider__nav',
      rows: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<span class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
      nextArrow: '<span class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000
    });

    $('#product-slider__nav').slick({
      asNavFor: '#product-slider__main',
      rows: 1,
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true,
      adaptiveHeight: true,
      dots: false,
      arrows: false
    });
    */

    $(".social-share").click(function() {
      $(this).toggleClass("is-visible");
    });

    $(".nav-tabs-toggle-btn").click(function() {
      $(".tricks-tabs-top").toggleClass("tabs-visible");
      $(".tricks-tabs-top ul.nav.nav-tabs.blog-filters").toggle();
    });


        // ZOOM
    //$('.zoom').zoom();

    // STYLE GRAB
    //$('.zoom--grab').zoom({ on:'grab' });

    // STYLE CLICK
    //$('.zoom--click').zoom({ on:'click' });

    // STYLE TOGGLE
    //$('.zoom--toggle').zoom({ on:'toggle' });
  /*
    $('#product-slider__main').slickLightbox({
      itemSelector : '.zoom img',
      navigateByKeyboard : true,
      src: 'src',
      lazy: true
    });
    */
    
    $('.product-slider-for').slick({
      fade: false,
      dots : false,
      lazyLoad: 'progressive',
      swipe:true,
      asNavFor: '.product-slider-nav',
      rows: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<span class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
      nextArrow: '<span class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000
      });

      $('.product-slider-nav').slick({
        asNavFor: '.product-slider-for',
        rows: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        adaptiveHeight: true,
        dots: false,
        arrows: false
      });
    
    $('[data-fancybox="product-gallery"]').fancybox({

      slideShow  : true,

      fullScreen : false,

      transitionEffect: "slide",

      arrows: true,

      thumbs : false,

      infobar : false,

    });
    
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    } else {
      $('.product-slider-for .slick-slide').zoom();
    }
    

      $(".qty-btn").on("click", function (e) {
        e.preventDefault();
        
        var input = $(this).closest('.pro-qty').find('input');
        var ip = parseInt(input.val());
        if($(this).hasClass('inc')) {
          ip = ip + 1;
        } else {
          ip = ip - 1;
        }
        if(ip==0) {
          return false;
        }
        input.val(ip)

    });
    
    $(document.body).on('click', '.register-close-btn',function(e){
      window.history.back();
    });
    
    var showChar = 90;
  var ellipsestext = '...';
  var moretext = 'Mehr lesen';
  var lesstext = 'Weniger lesen';
    
    $('.product-benefit-content p').each(function() {
    var content = $(this).html();

    if(content.length > showChar) {

      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);

      var html = c + '<span class="moreellipses">' + ellipsestext+ '</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

      $(this).html(html);
    }

  });
    
    $(".product-benefit-content .morelink").click(function(){
    if($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moretext);
    } else {
      $(this).addClass("less");
      $(this).html(lesstext);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });
    
    $(document.body).on('click', '.content-slide-article',function(e){
      e.preventDefault();
      var $this = $(this);
      var id = $this.data('id');
      var heading = $('#content-slide-heading-'+id).html();
      var content = $('#content-slide-content-'+id).html();
      var video = $('#content-slide-video-'+id).html();
      $('.tips-pop-heading').empty().html(heading);
      $('.tips-pop-content').empty().html(content);
      $('.tips-pop-video').empty().html(video);
      $('#tips-article-pop').modal('show');
    });
    
    $(document.body).on('click', '.tips-article',function(e){
      e.preventDefault();
      var $this = $(this);
      var id = $this.data('id');
      var heading = $('#tips-heading-'+id).html();
      var content = $('#tips-content-'+id).html();
      var video = $('#tips-video-'+id).html();
      $('.tips-pop-heading').empty().html(heading);
      $('.tips-pop-content').empty().html(content);
      $('.tips-pop-video').empty().html(video);
      $('#tips-article-pop').modal('show');
    });
    
    $("#tips-article-pop").on('hide.bs.modal', function() { 
      $('.tips-pop-heading').empty();
      $('.tips-pop-content').empty();
      $('.tips-pop-video').empty();
    }); 
    
    var url1 = $("#videoModal-product-irrigation-solution iframe").attr('src'); 
    $("#videoModal-product-irrigation-solution").on('hide.bs.modal', function() { 
      $("#videoModal-product-irrigation-solution iframe").attr('src', ''); 
    }); 
    $("#videoModal-product-irrigation-solution").on('show.bs.modal', function() { 
      $("#videoModal-product-irrigation-solution iframe").attr('src', url1); 
    });
    
    var url = $(".video-modal-frame").attr('src'); 
    $(".video-modal").on('hide.bs.modal', function() { 
      $(".video-modal-frame").attr('src', ''); 
    }); 
    $(".video-modal").on('show.bs.modal', function() { 
      $(".video-modal-frame").attr('src', url); 
    });
    
    $(document.body).on('click', '.blog-load-more a',function(e){
     e.preventDefault();
      var $this = $(this);
      var $parent = $this.closest('.blog-items');
      var $item = $parent.find('.blog-loop');
      var count = 0;
      var count2 = 0;
      $($item).each(function(i,v){
        if($(this).hasClass('d-none')){
          count++;
          if(count > 3){
            return;
          }
          $(this).removeClass('d-none');
          
        }
      });
      
      $($item).each(function(i,v){
        if($(this).hasClass('d-none')){
          count2++;
        }
      });
      
      
      if(count2 == 0) {
        $this.hide();
      }
   });
    
    $(".product-ratting a").on('click', function(e) {
      e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".home-testimonials-section").offset().top
        }, 2000);
    });
    
    $("body").on("click", ".video-play", function(e){
      //e.preventDefault();
        var video_url = $(this).data('src');
        
        $('#videoModal').find('.modal-body iframe').attr("src", '');
        $('#videoModal').find('.modal-body iframe').attr("src", video_url);
    });
    
    $("body").on("click", ".video-slide-play", function(e){
      //e.preventDefault();
        var video_url = $(this).data('src');
      
      	var section_id = $(this).data('section-id');
        
        $('#videoModal_' + section_id).find('.modal-body iframe').attr("src", '');
        $('#videoModal_' + section_id).find('.modal-body iframe').attr("src", video_url);
    });
    
    $("body").on("click", ".accordion-video-play, .cta-video-play", function(e){
      //e.preventDefault();
        var video_url = $(this).data('src');
      	var section_id = $(this).data('section-id');
        
        $('#videoModal__' + section_id).find('.modal-body iframe').attr("src", '');
        $('#videoModal__' + section_id).find('.modal-body iframe').attr("src", video_url);
    });

    $("#videoModal").on('shown.bs.modal', function(){
        var url = $('#videoModal').find('.modal-body iframe').attr('src');
        $('#videoModal').find('.modal-body iframe').attr('src', url);
    });
    
    /* Assign empty url value to the iframe src attribute when
    modal hide, which stop the video playing */
    $("#videoModal").on('hide.bs.modal', function(){
        $('#videoModal').find('.modal-body iframe').attr('src', '');
    });
    
    $('.videoModal__Popup').each(function(){
    var $this = $(this);
      $($this).on('shown.bs.modal', function(){
          var url = $($this).find('.modal-body iframe').attr('src');
          $($this).find('.modal-body iframe').attr('src', url);
      });
      
      $($this).on('hide.bs.modal', function(){
          $($this).find('.modal-body iframe').attr('src', '');
      });
    });
    
    
    $('.template-article .blog-detail-cont').find('img').each(function(){
    	var $this = $(this);
      	var alt = $this.attr('alt');
       	$this.wrap('<div class="blog-detail-cont-img"><div class="blog-detail-img"></div></div>');
        if(alt != '') {
			$this.parent('.blog-detail-img').after('<div class="blog-detail-ttx"><p>'+alt+'</p></div>');
        }
    });
    
    $('.template-article .blog-detail-cont').find('iframe').each(function(){
    	var $this = $(this);

       	$this.wrap('<div class="blog-detail-cont-iframe"></div>');
    });
    
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
  };
    
    var customer_posted = getUrlParameter('customer_posted');
    if(customer_posted == 'true') {
    	//$('#newsletterModal').modal('show');
      $('html, body').animate({
        scrollTop: $(".home-komm-section").offset().top
      }, 'slow');
    }
    
    $(document.body).on('click', '.search-load-more a', function(e){
    	e.preventDefault();
      var $this = $(this);
      var search_url = $this.data('url');
      $.ajax({
            type: 'get',
            url: search_url,
            dataType: 'html',
            success: function( data ) {
              var elements = $(data);
                var content = elements.find('.list-view-items').html();
              var loadmore = elements.find('.search-load-more').html();
              $('.list-view-items').append(content);
              $('.search-load-more').html(loadmore);
                
            }
        });
    });
    
    if ($(".link-list-section .link-list-items").length) {
      var a = $(".link-list-section .link-list-items").isotope({
        singleMode: true,
        masonry: {
          columnWidth: '.grid-sizer, .grid-sizer-second, .grid-sizer-three'
        },
        //columnWidth: ".grid-sizer, .grid-sizer-second, .grid-sizer-three",
        itemSelector: ".link-list-item, .link-list-item-second, .link-list-item-three",
        transformsEnabled: true,
        transitionDuration: "700ms",
        layoutMode: 'fitRows'
      });
      a.imagesLoaded(function() {
        a.isotope("layout");
      });
      
      $(".link-list-section .link-list-filters").on("click", "a.link-list-filter", function(b) {
        b.preventDefault();
        var c = $(this).attr("data-filter");
        a.isotope({
          filter: c
        });
        $(".link-list-section .link-list-filters a.link-list-filter").removeClass("link-list-filter_active");
        $(this).addClass("link-list-filter_active");
        return false;
      });
      a.isotope("on", "layoutComplete", function(a, b) {
        //var c = b.length;
        //$(".num-album").html(c);
      });
    }
    
    // Add smooth scrolling to all links
    $("a").on('click', function (event) {

      // Make sure this.hash has a value
      // before overriding default behavior
      if (this.hash !== "") {

        // Prevent default anchor
        // click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method 
        // to add smooth page scroll
        // The optional number (800) specifies
        // the number of milliseconds it takes
        // to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 1000, function () {

          // Add hash (#) to URL when done 
          // scrolling (default click behavior)
          window.location.hash = hash;
        });
      } // End if
    });
    
    $(".csmt_main_page").on('change', function() {
      if($(this).hasClass('switch-checked')) {
      	$(this).removeClass('switch-checked');
        window.location='/pages/vertrieb';
          return false;
      } else {
        $(this).addClass('switch-checked');
      	window.location='/';
          return false;
      }

    });
    
  }
  
  initShopify();
  
  $(document)
 .on( 'shopify:section:load', initShopify )
 .on( 'shopify:section:unload', initShopify );   
});


/****/


/*

$('input#check1:checkbox').change(function(){
    if($(this).is(":checked")) {
        $('.header-switch-slider').addClass("menuitemshow");
    } else {
        $('.header-switch-slider').removeClass("menuitemshow");
    }
});

*/


/* Cookies.js (https://fastcdn.org/Cookies.js/1.2.2/cookies.min.js)*/
(function(g,f){'use strict';var h=function(e){if("object"!==typeof e.document)throw Error("Cookies.js requires a `window` with a `document` object");var b=function(a,d,c){return 1===arguments.length?b.get(a):b.set(a,d,c)};b._document=e.document;b._cacheKeyPrefix="cookey.";b._maxExpireDate=new Date("Fri, 31 Dec 9999 23:59:59 UTC");b.defaults={path:"/",secure:!1};b.get=function(a){b._cachedDocumentCookie!==b._document.cookie&&b._renewCache();a=b._cache[b._cacheKeyPrefix+a];return a===f?f:decodeURIComponent(a)};
b.set=function(a,d,c){c=b._getExtendedOptions(c);c.expires=b._getExpiresDate(d===f?-1:c.expires);b._document.cookie=b._generateCookieString(a,d,c);return b};b.expire=function(a,d){return b.set(a,f,d)};b._getExtendedOptions=function(a){return{path:a&&a.path||b.defaults.path,domain:a&&a.domain||b.defaults.domain,expires:a&&a.expires||b.defaults.expires,secure:a&&a.secure!==f?a.secure:b.defaults.secure}};b._isValidDate=function(a){return"[object Date]"===Object.prototype.toString.call(a)&&!isNaN(a.getTime())};
b._getExpiresDate=function(a,d){d=d||new Date;"number"===typeof a?a=Infinity===a?b._maxExpireDate:new Date(d.getTime()+1E3*a):"string"===typeof a&&(a=new Date(a));if(a&&!b._isValidDate(a))throw Error("`expires` parameter cannot be converted to a valid Date instance");return a};b._generateCookieString=function(a,b,c){a=a.replace(/[^#$&+\^`|]/g,encodeURIComponent);a=a.replace(/\(/g,"%28").replace(/\)/g,"%29");b=(b+"").replace(/[^!#$&-+\--:<-\[\]-~]/g,encodeURIComponent);c=c||{};a=a+"="+b+(c.path?";path="+
c.path:"");a+=c.domain?";domain="+c.domain:"";a+=c.expires?";expires="+c.expires.toUTCString():"";return a+=c.secure?";secure":""};b._getCacheFromString=function(a){var d={};a=a?a.split("; "):[];for(var c=0;c<a.length;c++){var e=b._getKeyValuePairFromCookieString(a[c]);d[b._cacheKeyPrefix+e.key]===f&&(d[b._cacheKeyPrefix+e.key]=e.value)}return d};b._getKeyValuePairFromCookieString=function(a){var b=a.indexOf("="),b=0>b?a.length:b,c=a.substr(0,b),e;try{e=decodeURIComponent(c)}catch(f){console&&"function"===
typeof console.error&&console.error('Could not decode cookie with key "'+c+'"',f)}return{key:e,value:a.substr(b+1)}};b._renewCache=function(){b._cache=b._getCacheFromString(b._document.cookie);b._cachedDocumentCookie=b._document.cookie};b._areEnabled=function(){var a="1"===b.set("cookies.js",1).get("cookies.js");b.expire("cookies.js");return a};b.enabled=b._areEnabled();return b},e="object"===typeof g.document?h(g):h;"function"===typeof define&&define.amd?define(function(){return e}):"object"===typeof exports?
("object"===typeof module&&"object"===typeof module.exports&&(exports=module.exports=e),exports.Cookies=e):g.Cookies=e})("undefined"===typeof window?this:window);

$(document).ready(function() {
  function switchToCurrency(country) {
    var cswitcher = document.querySelector('select.currency-switcher');
    var currencies = {"default": "EUR", "US": "USD", "ID": "USD", "UK": "GBP", "GB": "GBP", "AU": "AUT", "AM": "CAD", "CA": "CAD"}; //"CH": "CHF", 
    var cc_code 		 = currencies.default;

    if( currencies.hasOwnProperty(country) ) {
      cc_code = currencies[country];
    }

    var gt_auto_currency = localStorage.getItem("gt_auto_currency") ? JSON.parse(localStorage.getItem("gt_auto_currency")) : {};
    var cselected = $(cswitcher).val();

    if(cc_code != cselected) { //!gt_auto_currency.hasOwnProperty(country) && 
      gt_auto_currency[country] = 1
      $('div.currency-switcher .option[data-value="'+ cc_code +'"]').click().click();
    }
    localStorage.setItem("gt_auto_currency", JSON.stringify(gt_auto_currency));
  }

  function getCustomerCountry() {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
          if (xhr.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
              if (xhr.status == 200 && xhr.responseText) {
                  var cc = JSON.parse(xhr.responseText).country_code
                  Cookies.set('gt_country_code', cc, {expires: 30, path: '/', domain: location.host});
                  switchToCurrency(cc);
              }
          }
      };	
      xhr.open("GET", "https://tdns.gtranslate.net/tdn-bin/geo-data", true);
      xhr.send();
  }

  var timer = Date.now();
  var gt_interval = setInterval(function(){
    if(!document.querySelector('.currency-switcher') && Date.now() - timer < 45000) {
      return false;
    }
    else {
      clearInterval(gt_interval);
    }

    if( !Cookies.get('gt_country_code')) {
        getCustomerCountry();
    } else {
        switchToCurrency(Cookies.get('gt_country_code'));
    }
  }, 3000);
});


let faqInfo = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Wie funktionieren Baumbeutel?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ein Baumbewässerungsbeutel ist die ideale Bewässerungs­hilfe für Bäume. Der Beutel wird wie eine Jacke um den Stamm gelegt, mit einem Reißver­schluss zugezogen und dann mit Wasser aufgefüllt. Damit sparst Du Wasser, Zeit, Geld und wirst zum #baumretter"
        }
      }, {
        "@type": "Question",
        "name": "Wie funktioniert die Tröpfchenbewässerung für Bäume?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Die Baumbewässerungsbeutel sind so aufgebaut, dass Wasser aus zwei Löchern an den unteren Faltstellen heraustropft. Eines Links und eines Rechts. Durch das aufschütteln des Beutels nach Anleitung, bewässert der Baumbeutel mit einer Füllung von 75 Litern Wasser, Tropfen für Tropfen über einen Zeitraum von 6-9 Stunden den Boden unter den Baumbeuteln. Der Boden unter dem Bewässerungsbeutel ist zudem durch den Beutel vor der einwirkenden Sonne geschützt und bleibt in der Bewässerungszeit feucht. Der feuchte Boden ist ideal, um dem Baum über die gesamte Zeit der Bewässerung, die Wasseraufnahme zu ermöglichen und seine Wasserspeicher zu füllen. Dieses Prinzip ist auch unter der so genannten Tröpfchenbewässerung bekannt."
        }
      }, {
        "@type": "Question",
        "name": "Der Bewässerungsbeutel entleert sich zu schnell (unter 6h)?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Die Baum Bewässerung Beutel sind so aufgebaut, dass Wasser aus zwei Löchern an den unteren Faltstellen heraustropft.<br\/>Diese Löcher sind jeweils eines Links und eines Rechts. Wenn diese nicht durch das aufschütteln bei der Befüllung richtig liegen, läuft das Wasser schneller ab als in 6-9 Stunden. <br\/>Schaue bitte einmal in der Anleitung, wie die Beutel richtig aufgeschüttelt werden.<\/p><p><br\/>Lösungen:<br\/>Kann es sein, dass die Beutel in einer Kuhle\/Hohlraum um den Baum stehen?<br\/>Dann bitte auch hier einmal nachsehen ob das PVC durch diese Position die Löcher auseinanderdrückt.<br\/>Durch ein leichtes zupfen können die Löcher richtig gestellt werden.<br\/><br\/>Bitte schau doch einmal, ob diese Lösungsvorschlag bei Dir hilft.<br\/>Sonst melde Dich bitte sofort bei unserem Support oder buche einen kostenlosen Termin. Wir helfen Dir und finden eine Lösung.<\/p>"
        }
      }, {
        "@type": "Question",
        "name": "Der Bewässerungsbeutel entleert sich zu langsam (über 24h)?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Die Bewässerungsbeutel sind so aufgebaut, dass Wasser aus zwei Löchern an den unteren Faltstellen heraustropft.<br\/>Diese Löcher sind jeweils eines Links und eines Rechts. Wenn diese nicht durch das aufschütteln bei der Befüllung frei sind, läuft das Wasser langsamer ab als in 6-9 Stunden. Schaue bitte einmal in der Anleitung wie die Beutel richtig aufgeschüttelt werden.<br\/><br\/>Lösungen:<br\/>1) Prüfe ob das PVC an diesen Stellen vielleicht leicht zusammenklebt und versuche dort einmal zu zupfen.<br\/>2) Kann es sein, dass die Beutel in einer Kuhle\/Hohlraum um den Baum stehen?<br\/>Dann bitte auch hier einmal nachsehen ob das PVC durch diese Position die Löcher verschließt.<br\/>Durch ein leichtes zupfen können die Löcher dann freigestellt werden.<br\/><br\/>Bitte schau doch einmal, ob eine dieser Lösungsvorschläge bei Dir helfen.<br\/><br\/>Sonst melde Dich bitte sofort bei unserem Support oder buche einen kostenlosen Termin. Wir helfen Dir und finden eine Lösung.<\/p>"
        }
      }, {
        "@type": "Question",
        "name": "Wo finde ich die Anleitung für die Baumbeutel?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":"<p>Die Anleitung kann man hier downloaden: <a href=\"\/blogs\/baumwissen\/anleitung-fur-die-nutzung-von-baum-bewasserungsbeutel\" target=\"_blank\" title=\"Anleitung für die Nutzung von Baum Bewässerungsbeutel\"><strong>baumbad Anleitung<\/strong><\/a><\/p>"
			}		
		}, {
        "@type": "Question",
        "name": "Kann ich den Baumbeutel reparieren?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Ja das ist möglich. Wir haben dafür ein kostenloses Reparaturset entwickelt und eine <a href=\"\/blogs\/baumwissen\/baumbeutel-reparieren-anleitung-vergleich\" title=\"Baumbeutel reparieren - der große Vergleich\">Anleitung für die Reparatur<\/a> geschrieben. Für Kostenlose Flicken Schreiben Sie uns einfach eine Nachricht.  <a href=\"\/pages\/kontakt\" title=\"Kontakt\">Zum Kontaktformular<\/a><\/p>"
			}
		}, {
        "@type": "Question",
        "name": "Wie oft sollte ich meinen Baum durch gießen bewässern?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p><strong>Zur weiteren Nutzung kommt nun die Frage, ob wir eine ständige Befüllung (täglich) oder beispielsweise eine Befüllung zweimal in der Woche empfehlen.<\/strong><br\/><br\/>Es ist nicht immer einfach festzulegen, welcher Baum wieviel Wasser benötigt. Wir raten daher lieber etwas weniger zu gießen als zu viel. Bei den Baumbeuteln handelt es sich um eine Gießunterstützung, um den Bäumen in einer trockenen Periode zu helfen. Bäume haben aus diesem Grund auch Wurzeln, die in verschiedene Erdtiefen reichen, wo gegebenenfalls noch Feuchtigkeit enthalten ist. Jeder Baum speichert Wasser in den Blättern, Ästen, dem Stamm und den Wurzeln. Das ist ähnlich wie bei Lebewesen. Wenn diese Speicher voll sind, können die Pflanzen eine längere Zeit auch ohne zusätzliches Wasser überleben. Wenn die Speicher eines Baumes sich entleeren, zeigt er dies meist als erstes über die Blätter und lässt sie hängen. Wenn man die Möglichkeit hat, sollte spätestens an diesem Punkt unterstützt werden.<br\/><br\/>Ideal ist es, den Baum in trockenen Phasen kontinuierlich zu unterstützen. Am besten startet man den Baum, alle zwei Wochen einmal zu bewässern, auch wenn es noch nicht so trocken ist. Falls die Wettervohersagen auf eine Trockenperiode hinweisen, raten wir schnellstmöglich mit einer wöchentlichen Unterstützung zu beginnen und in der Trockenperiode zweimal die Woche zu bewässern.<\/p>"
		  }
		}, {
        "@type": "Question",
        "name": "Ist ein Baumbeutel für Bäume mit 30cm Umfang gedacht?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Einen Baumbeutel zieht man dem Baum an wie eine Jacke. Dies geht in wenigen Sekunden ohne großen zeitlichen Aufwand. Ein<br\/>einzelner baumbad Baumbeutel ist für das gießen von Bäumen mit einem Umfang von maximal 30cm ausgelegt. Erst bei älteren Bäumen, die diesen Umfang überschritten haben, werden mehrere baumbad Beutel benötigt:<br\/>2 Baumbeutel bis 60cm<br\/>3 Baumbeutel bis 90cm<br\/>4 Baumbeutel bis 120cm<br\/>usw.<br\/><strong>Der Umfang des Baumes (in cm) geteilt durch 30 ergibt die Anzahl der für diesen Baum benötigten Baumbeutel.<\/strong><\/p>"
			}
		}, {
        "@type": "Question",
        "name": "Muss der Baumbeutel immer um den Baum herum gelegt werden?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Normalerweise ist es ideal dem Baum den baumbad Baumbeutel wie eine Jacke anzuziehen. Dies geht ohne großen zeitlichen Aufwand mit wenigen Handgriffen. Ein einzelner baumbad Baumbeutel ist für das gießen von Bäumen mit einem Umfang von maximal 30cm ausgelegt.<br\/>Erst bei älteren Bäumen, die diesen Umfang überschritten haben, werden mehrere baumbad Bewässerungsbeutel nötig. Diese lassen sich durch die clevere Reißverschlusslösung miteinander verbinden.<br\/>Ein ähnliches Problem weisen Äste und Verästelungen auf, die sich dort befinden, wo der Bewässerungsbeutel normal um den Baum gelegt wird. In solch einem Fall kann der Beutel auch neben den zu wässernden Baum gestellt werden. Am besten geht dies durch eine Holzstange oder einen Metallstab. Dieser muss in den Boden eingebracht werden ohne größere Wurzeln zu beschädigen. Der Baumbeutel steht von sich aus schon sehr stabil und benötigt nur eine kleine Unterstützung.<\/p>"
		  }
		}, {
        "@type": "Question",
        "name": "Hecken und Sträucher mit einem Baumbeutel gießen, geht das ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Hecken und Sträucher haben dort wo beim Baum der glatte Stamm ist meist schon vom Boden ab, Äste und Verästelungen, die sich dort befinden, wo der Bewässerungsbeutel normaler Weise um den Baum gelegt wird. In solch einem Fall kann der Beutel auch neben die zu wässernde Hecke bzw. den zu bewässernden Strauch gestellt werden. Am besten geht dies durch eine Holzstange oder einen Metallstab. Dieser muss in den Boden eingebracht werden ohne größere Wurzeln zu beschädigen. Der Baumbeutel steht von sich aus schon sehr stabil und benötigt nur eine kleine Unterstützung.<br\/><br\/>Eine Anleitung wie eine Bewässerung mit einem Wassersack an einer Hecke und Sträuchern funktioniert findet ihr in diesem Video:<\/p>"
		  }
		}, {
        "@type": "Question",
        "name": "Wie lange hält der Beutel? Was verkürzt die Lebensdauer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Der Baum Wassersack ist ein PVC-Beutel der ganz einfach aufgebaut ist um ihn so langlebig wie möglich zu bekommen. Dieser Beutel besteht aus einem Reiß- und Stoßfestem Material mit einer stützenden Verwebung.<\/p><p><br\/><strong>Die Lebensdauer wird verringert durch:<\/strong><br\/>- nicht ordnungsgemäßen Umgang (siehe Anleitung) mit dem Beutel<br\/>- Wettereinflüsse wie Sturm, Hagel, Frost oder auch Sonne (unser Beutel hat einen UV-Schutz)<br\/>- Hunde die über einen sehr langen Zeitraum an ihn pinkeln<br\/>- Rasenmäher oder Mährobotter<br\/>- Algen können nach sehr langer Benutzung die zwei Löcher verstopfen<br\/>- Schmutzwasser, beziehungsweise Verunreinigungen im Beutel könnten die Löcher verstopfen<br\/>- Düngerzusätze (FAQ) (je nach chemischer Zusammensetzung)<br\/>- Winterdienste die Schnee fegen<br\/>- Mader oder größere Wildtiere (nur wenn es sehr sehr trocken ist und diese kein Trinkwasser mehr finden)<br\/>- Vandalismus (nur um wirklich alles zusammenzufassen)<\/p><p><br\/><strong>Tipps für eine lange Lebensdauer: <\/strong><\/p><p>Benutzen Sie die Beutel am besten nur in den Jahresphasen, in denen Sie benötigt werden und legen Sie diese dann getrocknet und gereinigt an einen trockenen Platz, damit sich keine Algen bilden und der Beutel geschützt ist. Vermeiden Sie möglichst lebensverkürzende Umstände.<\/p>"
		  }
		}, {
        "@type": "Question",
        "name": "Löcher im Baumbeutel, aber woher?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Es kann vorkommen, dass Tiere, insbesondere in Zeiten von starker Hitze und Dürre, kein Wasser mehr finden und aus der Not heraus die Beutel anknabbern. Dabei handelt es sich meistens um kleine Nagetiere wie Mäuse aber auch Mader oder Füchse können an die Beutel gehen.<br\/>Wir haben herausgefunden, wie Du Tierbisse bei den Bewässerungsbeutel verhindern kannst.<br\/>Stelle auf deinem Grundstück kleine Schüsseln auf, die Du beim Füllen der Beutel gleich mit befüllen kannst. <br\/>Tipp: Die Schüsseln sollten bis zum Rand in der Erde stecken, sodass es keinen überstehenden Rand gibt, damit auch kleine Mäuschen an das Wasser kommen können, um zu trinken.<br\/><br\/>Für die Reparatur der Beutel mit wenigen Handgriffen, haben wir diesen [BLOGBEITRAG] verfasst. Dort wird erklärt, wie du Baumbeutel mit Haushaltsutensilien reparieren kannst. Das Kaufen von Reperatursets ist nicht notwendig, um die Beutel zu flicken. Es können dazu Restmaterialflicken und Recyclingflicken angefordert werden.<\/p>"
			}
		}, {
        "@type": "Question",
        "name": "Was sind diese grünen Beutel an den Bäumen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Vielleicht hast Du die Baumbeutel auch schon in Deiner Stadt gesehen. Vielleicht hat sogar Dein Nachbar schon einen baumbad Bewässerungsbeutel um einen seiner Bäume. Wieso diese Beutel um den Baum angebracht sind?   Also wir wollen Dir das einmal kurz erklären: „Durch den Klimawandel hat sich das Klima in den letzten Jahren kontinuierlich verändert. Tendenziell ist es dadurch in Europa wärmer geworden, zudem haben sich die Niederschläge verringert. Alles in allem ist es nun nachweislich trockener. Das hat zur Folge, dass viele Pflanzen und Bäume unter Wassermangel leiden. Die grünen Säcke an den Bäumen sind Bewässerungsbeutel die zur Unterstützung verwendet werden. Durch sie werden sowohl Wasserressourcen als auch Zeit beim gießen eingespart. Was der Umwelt, dem Baum und dem Menschen hilft.\"<br\/><br\/>baumbad Bewässerung<br\/> Stefan Flüs<br\/><br\/><\/p>"
			}
		}, {
        "@type": "Question",
        "name": "Welche Wassermengen ein Baum (Stammdurchmesser ca. 20-25 cm) benötigt?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Jeder Tropfen ist wichtig um die Speicher eines Baumes zu füllen. Gerade in trockenen Zeiten kann man seinen Baum durch die Baumbeutel unterstützen. Wieviel Wasser einzelne Bäume verbrauchen ist dabei unterschiedlich. Die Bäume entnehmen kontinuierlich Wasser aus dem Boden in tieferen Schichten. Bei Neupflanzungen hilft eine häufigere Bewässerung auch dabei Wurzeln zu bilden, gerade in dem feuchten Bereich, der unter einem Baumbeutel vorliegt.<\/p><p>Wir Empfehlen daher 75 Liter (ein voller Beutel)  oder auch 150 Liter (zwei volle Beutel) pro Gießgang<\/p>"
		  }
		}, {
        "@type": "Question",
        "name": "Bäume speichern Wasser! Ja und wieviel Wasser speichert ein Baum? Und wo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "<p>Jeder Baum speichert Wasser in den Blättern, Ästen, dem Stamm und den Wurzeln. Das ist ähnlich wie bei Lebewesen. Wenn diese Speicher voll sind, können die Pflanzen eine längere Zeit auch ohne zusätzliches Wasser überleben. Wenn die Speicher eines Baumes sich entleeren, zeigt er dies meist als erstes über die Blätter und lässt sie hängen. Wenn man die Möglichkeit hat, sollte der Baum spätestens an diesem Punkt unterstützt werden.<\/p>"}
       }]
    })

document.querySelectorAll('.site-nav.links')[0].children[2].children[0].innerText === 'Fragen & Antwort' ? document.querySelectorAll('.site-nav.links')[0].children[2].children[0].innerText = 'Fragen & Antworten' : null;

let faqscript = document.createElement("script");
faqscript.type="application/ld+json";
faqscript.innerHTML = faqInfo;

if (location.pathname === '/pages/fragen-und-antworten') {
	document.getElementsByTagName('head')[0].appendChild(faqscript);
}

if (location.pathname === '/pages/vertrieb') {
  document.getElementsByClassName('banner-left-txt')[0].children[0].outerHTML = '<p class="vertrieb-premium-baun-preheading"> baumbad - Ihr Partner für </p>'
  document.getElementsByClassName('banner-left-txt')[0].childNodes[5].outerHTML = '<p class="vertrieb-premium-baun-text-1"> Ein baumbad ist die ideale Bewässerungs­hilfe für Bäume im urbanen Raum. Der Beutel wird wie eine Jacke um den Stamm gelegt, Reißver­schluss zugezogen und mit Wasser aufgefüllt. </p>'
  document.getElementsByClassName('about-section-head')[1].children[0].outerHTML = '<h1 class="accordion-preheading">Schnelle Hilfe für Ihr Anliegen</h1>'
  document.getElementsByClassName('banner-left-txt')[0].childNodes[3].outerHTML = '<h1 class="sales-main-1">Premium Baum Bewässerungsbeutel</h1>'
  document.getElementsByClassName('cta-heading-1')[0].outerHTML = '<p class="cta-heading-1">Über 1000 Partner arbeiten bereits mit uns zusammen</p>'
  document.querySelectorAll('.cta__content.section-txt.cta__content--left')[0].childNodes[1].outerHTML = '<p class="cta-preheading-1">Die perfekte Werbefläche für Ihre Botschaft</p>'
  document.querySelectorAll('.cta__content.section-txt.cta__content--left')[0].childNodes[3].outerHTML = '<h2 class="cta-heading-1">Personalisieren  Sie Ihre/n Baumbeutel</h2>'
  document.querySelectorAll('.cta__content.section-txt.cta__content--right')[1].childNodes[1].outerHTML = '<p class="cta-preheading-1">Baumschulen schaffen Leben, wir schützen Leben</p>'
  document.querySelectorAll('.cta__content.section-txt.cta__content--right')[2].childNodes[1].outerHTML = '<p class="cta-preheading-1">Gemeinsam Bäume schützen</p>'
  document.getElementsByClassName('accordion-preheading')[0].outerHTML = '<p class="accordion-preheading">Schnelle Hilfe für Ihr Anliegen</p>'
  document.getElementsByClassName('cta-heading-1')[2].outerHTML = `<h2 class="cta-heading-1"> ${document.getElementsByClassName('cta-heading-1')[2].outerText} </h2>`
  document.getElementsByClassName('cta-heading-1')[3].outerHTML = `<h2 class="cta-heading-1"> ${document.getElementsByClassName('cta-heading-1')[3].outerText} </h2>`
  document.getElementsByClassName('link-list-heading')[0].outerHTML = `<h2 class="link-list-heading"> ${document.getElementsByClassName('link-list-heading')[0].outerText} </h2>`
}

if (location.pathname === '/pages/bedruckte-bewaesserungsbeutel') {
 document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[3].outerHTML = '<h1 class="tips-heading-1">Bedruckung &amp; Personalisierung</h1>'
 document.querySelectorAll('.cta__content.section-txt.cta__content--right')[0].childNodes[3].outerHTML = '<p class="cta-heading-1">Wir personalisieren Ihre Baumbewässerungsbeutel</p>'
 document.getElementsByClassName('team-preheading')[0].outerHTML = '<p class="team-preheading">Das baumbad Support Team</p>'
 document.getElementsByClassName('team-heading')[0].outerHTML = '<h2 class="team-heading">Ihre Ansprechpartner für Bedruckung</h2>'
 document.getElementsByClassName('contact-heading')[0].outerHTML = '<h2 class="contact-heading">Nehmen Sie Kontakt auf</h2>'
 document.getElementsByClassName('contact-cont-txt')[0].childNodes[1].outerHTML = '<h3 class="contact-cont-heading">Jetzt Termin vereinbaren</h3>'
 document.getElementsByClassName('contact-subheading')[0].outerHTML = '<h4 class="contact-subheading">Kostenloses Muster bestellen</h4>'
 document.getElementsByClassName('contact-subheading')[1].outerHTML = '<h4 class="contact-subheading">Bedruckung und Aufkleber</h4>'
 Array.from(document.getElementsByClassName('tips-tricks-1')).forEach(x => x.outerHTML = `<p class="tips-tricks-1">${x.outerText}</p>`)
 document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`

}

if (location.pathname === '/pages/foerderprogramme-umwelt-baumbewaesserung') {
  document.getElementsByClassName('team-preheading')[0].outerHTML = '<p class="team-preheading">Das baumbad Support Team</p>'
  document.getElementsByClassName('team-heading')[0].outerHTML = '<h2 class="team-heading">Ihre Ansprechpartner für Förderungen</h2>'
  document.getElementsByClassName('contact-heading')[0].outerHTML = '<h2 class="contact-heading">Nehmen Sie Kontakt auf</h2>'
  document.getElementsByClassName('contact-cont-txt')[0].childNodes[1].outerHTML = '<h3 class="contact-cont-heading">Jetzt Termin vereinbaren</h3>'
  document.getElementsByClassName('contact-subheading')[0].outerHTML = `<h4 class="contact-subheading">${document.getElementsByClassName('contact-subheading')[0].outerText}</h4>`
  document.getElementsByClassName('link-list-heading')[1].outerHTML = `<h2 class="link-list-heading"> ${document.getElementsByClassName('link-list-heading')[1].outerText} </h2>`
  document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
}

if (location.pathname === '/pages/baum-giesspatenschaften-staedte-gemeinden') {
  document.getElementsByClassName('cta-preheading-1')[0].outerHTML = '<p class="cta-preheading-1">Engagement fördern, Kassen entlasten</p>'
  document.getElementsByClassName('cta-heading-1')[0].outerHTML = '<h1 class="cta-heading-1">Mit Baumpatenschaften die Natur nachhaltig schützen</h1>'
  document.querySelectorAll('.cta__content.section-txt.cta__content--left')[0].childNodes[7].outerHTML = `<p class="cta-content-title">${document.querySelectorAll('.cta__content.section-txt.cta__content--left')[0].childNodes[7].outerText}</p>`
  document.getElementsByClassName('banner-left-txt')[0].childNodes[1].outerHTML = '<p class="banner-preheading-1">baumbad - jeder Baum verdient einen Freund</p>'
  document.getElementsByClassName('banner-left-txt')[0].childNodes[5].outerHTML = '<p class="banner-cont-title">Baumfreundschaften</p>'
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[1].outerHTML = '<h2 class="tips-tricks-1">Baumpatenschaften</h2>'
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[3].outerHTML = '<p class="tips-heading-2">So einfach funktionierts</p>'
  document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
  
  document.getElementsByClassName('team-preheading')[0].outerHTML = '<p class="team-preheading">Das baumbad Support Team</p>'
  document.getElementsByClassName('team-heading')[0].outerHTML = '<h2 class="team-heading">Ihr Ansprechpartner für Baumpatenschaften</h2>'
  
  document.getElementsByClassName('blog-detail-cont')[0].childNodes[1].outerHTML = '<h2 class="blog-detail-heading">\n                      \n                        Mehr zum Thema aus unserem Baumwissen Blog\n                      \n                      </h2>'
  
  function tipsTricks() {
  document.getElementsByClassName('home-tipps-txt')[3].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 7: Schreiben Sie uns! Wir setzen Ideen aktiv mit Ihnen um!</h3>'
  document.getElementsByClassName('home-tipps-txt')[4].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 1: Starten Sie ein Patenschaftsprogramm.</h3>'
  document.getElementsByClassName('home-tipps-txt')[5].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 2: Bürger:Innen können sich ab sofort engagieren.</h3>'
  document.getElementsByClassName('home-tipps-txt')[10].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 7: Schreiben Sie uns! Wir setzen Ideen aktiv mit Ihnen um!</h3>'
  document.getElementsByClassName('home-tipps-txt')[11].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 1: Starten Sie ein Patenschaftsprogramm.</h3>'
  document.getElementsByClassName('home-tipps-txt')[12].childNodes[0].outerHTML = '<h3 class="tips-tricks-title">Schritt 2: Bürger:Innen können sich ab sofort engagieren.</h3>'
  }
  setTimeout(tipsTricks, 1000)
  
}

if (location.pathname === "/") {
  document.getElementsByClassName('ur-txt')[0].children[0].outerHTML = '<p class="second-chg">„Mit unserem Baum Bewässerungssack reagieren wir auf den Klimawandel und möchten Dir helfen, Deine Bäume nachhaltig zu schützen.”</p>'
//   document.getElementsByClassName('product-list-item-price')[0].children[0].outerHTML = '<p class="second-chg-price">\n        <span class="price">\n          \n          €16,99\n          \n        </span>\n        \n        \n          <span class="discounted-price discounted">\n            <span class="money">€21,99</span>\n        </span>\n        \n      </p>'
//   document.getElementsByClassName('product-list-item-price')[1].children[0].outerHTML = '<p class="second-chg-price">\n        <span class="price">\n          \n          €79,99\n          \n        </span>\n        \n        \n          <span class="discounted-price discounted">\n            <span class="money">€94,95</span>\n        </span>\n        \n      </p>'
//   document.getElementsByClassName('product-list-item-price')[2].children[0].outerHTML = '<p class="second-chg-price">\n        <span class="price">\n          \n          €19,99\n          \n        </span>\n        \n        \n          <span class="discounted-price discounted">\n            <span class="money">€24,99</span>\n        </span>\n        \n      </p>'
  document.getElementsByClassName('testimonials-top-left')[0].children[0].outerHTML = '<h2 class="testimonial-chg-preheading">Was die baumbad Helden sagen</h2>'
  document.getElementsByClassName('testimonials-top-left')[0].children[1].outerHTML = '<p class="testimonial-chg-heading">Wir lieben unsere baumretter</p>'
  document.getElementsByClassName('home-cta-txt')[0].children[1].outerHTML = '<p class="name-chg">Michael K.</p>'
  document.getElementsByClassName('home-cta-txt-right')[0].children[0].outerHTML = '<p class="home-cta-txt-right-preheading">Der baumbad Bewässerungssack</p>'
  document.getElementsByClassName('home-cta-txt-right')[0].children[1].outerHTML = '<p class="home-cta-txt-right-heading">Hol dir deinen Premium Bewässerungs­beutel</p>'
  document.getElementsByClassName('home-cta-txt')[1].children[1].outerHTML = '<p class="name-chg">Michael K.</p>'
  document.getElementsByClassName('home-cta-txt-right')[1].children[0].outerHTML = '<p class="home-cta-txt-right-preheading">Der baumbad Bewässerungssack</p>'
  document.getElementsByClassName('home-cta-txt-right')[1].children[1].outerHTML = '<p class="home-cta-txt-right-heading">Hol dir deinen Premium Bewässerungs­beutel</p>'
  document.getElementsByClassName('irrigation-head')[0].children[1].outerHTML = '<p class="irrigation-heading">Baumschulen schaffen Leben, wir bei baumbad <span>schützen</span> Leben.</p>'
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[1].outerHTML = '<h2 class="tips-tricks-1">Richtige Baumbewässerung</h2>'
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[3].outerHTML = '<p class="tips-tricks-heading-1" style="font-size: calc(((var(--base-font-size) + 20)) * 1px) !important">Tipps &amp; Tricks</p>'
}

document.getElementsByClassName('footer-menu')[0].children[0].outerHTML = '<p class="footer-menu-1">baumbad</p>'
document.getElementsByClassName('footer-menu')[1].children[0].outerHTML = '<p class="footer-menu-1">Wissenswert</p>' 
document.getElementsByClassName('footer-menu')[2].children[0].outerHTML = '<p class="footer-menu-1">Rechtliches</p>' 
// document.getElementsByClassName('shop-txt-section')[0] !== undefined ? document.getElementsByClassName('shop-txt-section')[0].style.padding = '0' : null;

if (location.pathname === '/pages/uber-uns-baum-bewasserungs-startup') {
  document.getElementsByClassName('cta__content--right')[0].childNodes[3].outerHTML = '<p class="cta-heading-1">Die Natur ist das größte Geschenk auf Erden.</p>'
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = '<h1 class="kostenlose-preheading">baumbad</h1>'
  document.querySelectorAll('.image-text-inner-content')[0].childNodes[3].outerHTML = '<p class="uberuns-heading-1 lettering">„Die Natur schenkt uns das Leben und wir haben die Verant­wortung es zum Wohle aller zu schützen.”</p>'
}

if (location.pathname === '/pages/partner') {
 document.getElementsByClassName('about-section-head')[0].childNodes[1].outerHTML = '<p class="partner-preheading">Wir fördern und helfen</p>'
 document.getElementsByClassName('about-section-head')[0].childNodes[3].outerHTML = '<h1 class="partner-heading">Projekte &amp; Partner</h1>'
}

if (location.pathname === '/pages/club') {
 document.getElementsByClassName('kostenlose-heading')[0].outerHTML = '<h1 class="kostenlose-heading standard">Unser Vorteilsprogramm</h1>'
}

if (location.pathname === '/pages/expert') {
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = '<h1 class="kostenlose-heading standard" style="letter-spacing: 0px !important">Unser Baumexperte hilft dir</h1>'
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[1].outerHTML = '<p class="tips-tricks-1">Richtige Baumbewässerung</p>'
}

function tipsTitle() {
  function runText() { 
 	var tipstext = document.getElementsByClassName('tips-pop-content')[0].childNodes[0].outerText 
 	document.getElementsByClassName('tips-pop-content')[0].childNodes[0].outerHTML = `<h3 class="tips-cont-text">${tipstext}</h3>`
  }
  setTimeout(runText, 1200)
}

if (location.pathname === '/pages/bewaesserungsbeutel-staedte-kommunen') {
 document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = '<h1 class="kostenlose-preheading">baumbad für Städte &amp; Kommunen</h1>'
 document.getElementsByClassName('kostenlose-heading')[0].outerHTML = '<h2 class="kostenlose-heading standard">Ihr Ansprechpartner für urbane Baumbewässerung</h2>'
 document.getElementsByClassName('tips-tricks-1')[0].outerHTML = `<p class="tips-tricks-1"> ${document.getElementsByClassName('tips-tricks-1')[0].outerText} </p>`
 document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
}

if (location.pathname === '/pages/bewaesserungsbeutel-baumschulen') {
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = '<h1 class="kostenlose-preheading">baumbad für Baumschulen</h1>'
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = '<h2 class="kostenlose-heading standard">Ihr Ansprechpartner für Premium Baum Bewässerungsbeutel</h2>'
   document.getElementsByClassName('team-preheading')[0].outerHTML = '<p class="team-preheading">Das baumbad Support Team</p>'
  document.getElementsByClassName('team-heading')[0].outerHTML = '<h2 class="team-heading">Ihr Ansprechpartner für den Baumschulen &amp; Bedruckungen</h2>'
  document.querySelectorAll('.irrigation-slid-head .section-txt.text-center')[0].childNodes[1].outerHTML = '<p class="logos-heading">Viele Baumschulen vertrauen bereits auf <br>Baumbewässerungsbeutel von baumbad</p>'
  document.getElementsByClassName('tips-tricks-1')[0].outerHTML = `<p class="tips-tricks-1"> ${document.getElementsByClassName('tips-tricks-1')[0].outerText} </p>`
  document.getElementsByClassName('link-list-heading')[0].outerHTML = `<h2 class="link-list-heading"> ${document.getElementsByClassName('link-list-heading')[0].outerText} </h2>`
   document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
}

if (location.pathname === '/pages/bewaesserungsbeutel-galabau') {
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = '<h1 class="kostenlose-preheading">baumbad für GaLaBau Unternehmen</h1>'
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = '<h2 class="kostenlose-heading standard">Ihr Ansprechpartner für Premium Baum Bewässerungsbeutel</h2>'
  document.getElementsByClassName('team-preheading')[0].outerHTML = '<p class="team-preheading">Das baumbad Support Team</p>'
  document.getElementsByClassName('team-heading')[0].outerHTML = '<h2 class="team-heading">Ihr Ansprechpartner für den GalaBau &amp; Bedruckungen</h2>'
  document.querySelectorAll('.irrigation-slid-head .section-txt.text-center')[0].childNodes[1].outerHTML = '<p class="logos-heading">Viele GalaBau vertrauen bereits auf <br>Baumbewässerungsbeutel von baumbad</p>'
  document.getElementsByClassName('tips-tricks-1')[0].outerHTML = `<p class="tips-tricks-1"> ${document.getElementsByClassName('tips-tricks-1')[0].outerText} </p>`
  document.getElementsByClassName('link-list-heading')[0].outerHTML = `<h2 class="link-list-heading"> ${document.getElementsByClassName('link-list-heading')[0].outerText} </h2>`
   document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
}

if (location.pathname === '/pages/bewaesserungsbeutel-haendler') {
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = `<h1 class="kostenlose-preheading">${document.getElementsByClassName('kostenlose-preheading')[0].outerText}</h1>`
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = `<h2 class="kostenlose-heading standard">${document.getElementsByClassName('kostenlose-heading')[0].outerText}</h2>`
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[1].outerHTML = `<h2 class="tips-tricks-1">${document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[1].outerText}</h2>`
  document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[3].outerHTML = `<p class="tips-heading-2">${document.getElementsByClassName('home-tipps-left-inn')[0].childNodes[3].outerText}</p>`
  document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
  
  Array.from(document.getElementsByClassName('home-tipps-txt')).forEach(x => { 
    if (x.childNodes.length === 1) { 
        var tipstext = x.childNodes[0].outerText
        x.childNodes[0].outerHTML = `<h3 class="tips-tricks-title"> ${tipstext} </h3>`
    }
  })
}

if (location.pathname === '/pages/bewaesserungsbeutel-grosskunden') {
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = `<h1 class="kostenlose-preheading">${document.getElementsByClassName('kostenlose-preheading')[0].outerText}</h1>`
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = `<h2 class="kostenlose-heading standard">${document.getElementsByClassName('kostenlose-heading')[0].outerText}</h2>`
   document.getElementsByClassName('faq-accordion-1')[0].outerHTML = `<p class="accordion-preheading"> ${document.getElementsByClassName('faq-accordion-1')[0].outerText} </p>`
}

if (location.pathname === '/pages/ueber-uns-vertrieb') {
  document.getElementsByClassName('kostenlose-preheading')[0].outerHTML = `<h1 class="kostenlose-preheading">${document.getElementsByClassName('kostenlose-preheading')[0].outerText}</h1>`
  document.querySelectorAll('.image-text-inner-content')[0].childNodes[3].outerHTML = `<p class="uberuns-heading-1 lettering">${document.querySelectorAll('.image-text-inner-content')[0].childNodes[3].outerText}</p>`
  document.getElementsByClassName('cta-heading-1')[0].outerHTML = `<p class="cta-heading-1">${document.getElementsByClassName('cta-heading-1')[0].outerText}</p>`
}

if (location.pathname === '/pages/kontakt-vertrieb') {
  document.getElementsByClassName('contact-cont-txt')[0].childNodes[1].outerHTML = `<h3 class="contact-page-cont-heading">${document.getElementsByClassName('contact-cont-txt')[0].childNodes[1].outerText}</h3>`
  document.getElementsByClassName('contact-cont-txt')[1].childNodes[1].outerHTML = `<h4 class="contact-subheading">${document.getElementsByClassName('contact-cont-txt')[1].childNodes[1].outerText}</h4>`
  document.getElementsByClassName('contact-cont-txt')[2].childNodes[1].outerHTML = `<h4 class="contact-subheading">${document.getElementsByClassName('contact-cont-txt')[2].childNodes[1].outerText}</h4>`
  document.getElementsByClassName('contact-cont-txt')[3].childNodes[1].outerHTML = `<h4 class="contact-subheading">${document.getElementsByClassName('contact-cont-txt')[3].childNodes[1].outerText}</h4>`
}

if (location.pathname === '/pages/partner-vertrieb') {
  document.querySelectorAll('.about-section-head.text-center')[0].childNodes[1].outerHTML = `<p class="partner-preheading">${document.querySelectorAll('.about-section-head.text-center')[0].childNodes[1].outerText}</p>`
  document.querySelectorAll('.about-section-head.text-center')[0].childNodes[3].outerHTML = `<h1 class="partner-heading">${document.querySelectorAll('.about-section-head.text-center')[0].childNodes[3].outerText}</h1>`
}

if (location.pathname === '/pages/expert-vertrieb') {
  document.getElementsByClassName('kostenlose-heading')[0].outerHTML = `<h1 class="kostenlose-heading standard" style="letter-spacing: 0px !important">${document.getElementsByClassName('kostenlose-heading')[0].outerText}</h1>`
  document.getElementsByClassName('tips-tricks-1')[0].outerHTML = `<p class="tips-tricks-1"> ${document.getElementsByClassName('tips-tricks-1')[0].outerText} </p>`
}